export interface CommandAiIdentity {
  readonly surface: 'command_center' | 'main_command';
  readonly provider: string;
  readonly model: string;
  readonly label: string;
  readonly detail: string;
}

/**
 * Current configured planner identities.
 *
 * Command Center's edge planner defaults to Claude Sonnet 5 and may climb its
 * configured fallback ladder on provider/capacity failure.
 *
 * The direct one-Worker planner uses the locally installed Codex CLI, signed
 * in with the machine owner's ChatGPT account.
 */
export const COMMAND_CENTER_AI: CommandAiIdentity = {
  surface: 'command_center',
  provider: 'Anthropic',
  model: 'claude-sonnet-5',
  label: 'Claude Sonnet 5',
  detail: 'Primary Command Center planner. A configured fallback ladder may answer when the primary is unavailable.',
};

export const MAIN_COMMAND_AI: CommandAiIdentity = {
  surface: 'main_command',
  provider: 'OpenAI',
  model: 'codex-cli-account-default',
  label: 'ChatGPT plan via Codex CLI',
  detail: 'Local one-Worker planner using the Codex CLI signed in with the machine owner\'s ChatGPT account.',
};

export function commandAiBadgeLabel(identity: CommandAiIdentity = COMMAND_CENTER_AI): string {
  return `Command Center AI · ${identity.label}`;
}
